import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ODataConfiguration, ODataServiceFactory } from '@shared/odata';
import { GenericODataServiceProvider } from './services/generic-odata-service-provider.service';
import { ODataConfig } from './services/odata-config.service';

export function provideEngineOData(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: ODataConfiguration, useClass: ODataConfig },
    ODataServiceFactory,
    GenericODataServiceProvider,
  ]);
}
